import { getDefaultTeam } from "./getDefaultTeam";
import { updateDefaultTeam } from "./updateDefaultTeam";
import { getConfigsApp } from "./getConfigsApp";
import { getProductsConfig } from "./getProductsConfig";
import { getProductsCatalog } from "./getProductsCatalog";
import { patchConfigProducts } from "./patchConfigProducts";
import { updateConfigProduct } from "./updateConfigProduct";
import { uploadProductImage } from "./uploadProductImage";
import { removeProductImage } from "./removeProductImage";

export const configService = {
  getDefaultTeam,
  updateDefaultTeam,
  getConfigsApp,
  getProductsConfig,
  getProductsCatalog,
  patchConfigProducts,
  updateConfigProduct,
  uploadProductImage,
  removeProductImage,
};
